<template>
  <div class="container-autocomplete">
  <div class="row">
    <div class="col-sm-12 ">
                 
                    <vue-bootstrap-typeahead 
                    
                      v-debounce:200.lock="search"
                      v-model="query"
                      :data="resultados"
                      @hit="onSubmit"
                      size="md"
                      placeholder="Nome..."
                      :maxMatches="limiteResultados"
                      style=""
                      :inputClass="classe"
                      ref="typeahead"
                      :serializer="s => s.ED_NOME"
                      @input="atualizarNome"
                    />

                   
</div>



</div>
  </div>
</template>

<script>
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'

export default {
  name: 'AutocompleteCustom',
  components: {VueBootstrapTypeahead},
  props: {
    nome: String,
    url: String,
    classe: String,
    resultados: Array
   
  },
  data(){
    return {
      limiteResultados:50,
      query: ''
    }
  },
  methods:{
    atualizarNome(){
      this.$emit('update:nome', this.query);
    },
     search() {
       if(this.query.length > 1){
        let formData = new FormData();
        formData.append('query',this.query);
        fetch('https://www2.royaljardim.com.br/sistema/welcome/'+this.url,{method: "POST",body: formData})
          .then((response) => response.json())
          .then((data) => {
            this.$emit('update:resultados', data);
        
            //this.resultados = data;
          })
       }
       
    },
    preencher(edificio){
      this.$refs.typeahead.inputValue = edificio;
    },

    onSubmit(result) {
     
      if(result != undefined && result != null){
        this.$emit('update:nome', result);
         this.$emit('pronto',result);
         //this.$refs.typeahead.inputValue = "";
      }
    },
    adicionar(){
      if(this.query != ''){
         this.$emit('pronto',this.query);
         //this.$refs.typeahead.inputValue = "";
      }
    }
   
  },
  mounted(){
    
  }
}
</script>


